import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAuth } from '@/hooks/useAuth';
import { useT } from '@/i18n';
import { api } from '@/api/client';
export function Profile() {
    const { user } = useAuth();
    const { t } = useT();
    async function handleExport() {
        const data = await api.gdpr.export();
        const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `quintant-data-export-${new Date().toISOString().slice(0, 10)}.json`;
        a.click();
        URL.revokeObjectURL(url);
    }
    async function handleDelete() {
        if (!confirm(t.gdpr.deleteConfirm))
            return;
        await api.gdpr.deleteRequest();
        window.location.reload();
    }
    return (_jsxs("div", { className: "max-w-lg", children: [_jsx("h1", { className: "text-2xl font-bold mb-6", children: t.nav.settings }), _jsxs("div", { className: "bg-deep-charcoal rounded-lg p-4 mb-6", children: [_jsx("p", { className: "text-sm text-stone-gray mb-1", children: "Email" }), _jsx("p", { children: user?.email })] }), _jsxs("div", { className: "space-y-4", children: [_jsx("button", { onClick: handleExport, className: "btn-secondary text-sm w-full", children: t.gdpr.exportData }), _jsx("button", { onClick: handleDelete, className: "w-full text-sm px-6 py-3 border border-red-500/30 text-red-400 rounded-md hover:bg-red-500/10 transition-colors", children: t.gdpr.deleteAccount })] })] }));
}
